<template>
  <a-drawer class="product-add" title="产品相关" @close="onClose" :width="720" :visible="addVisiable" :maskClosable="false">

    <a-form-model ref="ruleForm" :model="form" :rules="rules">
      <a-form-model-item label="产品名称" prop="name" v-bind="formItemLayout">
        <a-input v-model="form.name" />
      </a-form-model-item>
      <a-form-model-item label="产品类型" prop="productType" v-bind="formItemLayout">
        <a-select v-model="form.productType">
          <a-select-option v-for="item in productTypeArr" :key="item.dictId" :value="item.dictId">{{item.valuee}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="产品描述" prop="desc" v-bind="formItemLayout">
        <a-textarea placeholder="产品描述" v-model="form.desc" :rows="3" />
      </a-form-model-item>
      <a-form-model-item label="产品图片" v-bind="formItemLayout">
        <UploadImgs :path="IMAGE_PRODUCT" :file-list="fileList" @_change="handleUploadImgChange"></UploadImgs>
        <a-tag color="orange">建议图片尺寸：400*460px</a-tag>
      </a-form-model-item>
      <a-form-model-item label="明星产品" prop="isStar" v-bind="formItemLayout">
        <div style="text-align: left;">
          <a-tag :color="starProduct?'#87d068':'red'">{{ starProduct?"是":"否" }}</a-tag>
          <a-switch size="small" :checked="starProduct" @change="handleStarProductChange" />
        </div>
      </a-form-model-item>
      <a-form-model-item label="附件详情" v-bind="formItemLayout">
        <UploadEnclosure :path="PDF_PRODUCT" :enclosure-list="enclosureList" @_change="handleUploadEnclosureChange"></UploadEnclosure>
      </a-form-model-item>
    </a-form-model>

    <div class="drawer-bootom-button">
      <!-- <a-popconfirm title="确定放弃编辑？" @confirm="onClose" okText="确定" cancelText="取消">
        <a-button style="margin-right: .8rem">取消</a-button>
      </a-popconfirm> -->
			<a-button @click="onClose" style="margin-right: .8rem">取消</a-button>
      <a-button @click="handleSubmit" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import {IMAGE_PRODUCT, PDF_PRODUCT} from "../../../utils/upload-path-map"
import UploadImgs from "../../../components/upload-imgs/UploadImgs"
import UploadEnclosure from "../../../components/upload-enclosure/UploadEnclosure"

const formItemLayout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 18 }
}

export default {
  name: "ProductAdd",
  components: {UploadImgs, UploadEnclosure},
  props: {
    addVisiable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formItemLayout,
      IMAGE_PRODUCT,
      PDF_PRODUCT,
      fileList: [],
      enclosureList: [],
      starProduct: false,
      productTypeArr: [],
      form: {
        name: "",
        productType: "",
        isStar: "0",
        desc: "",
        image: "",
        enclosure: null
      },
      rules: {
        name: [
          { required: true, message: '产品名称不能为空', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '产品类型不能为空', trigger: 'change' }
        ],
        image: [
          { required: true, message: '产品图片不能为空', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.productTypeArr = this.$store.state.dict.dicts.product_product_type
  },
  methods: {
    handleStarProductChange(val) {
      this.starProduct = val;
      this.form.isStar = val?'1':'0';
    },
    onClose() {
      // this.$refs.ruleForm.resetFields();
			this.reset();
      this.$emit("close");
    },
		reset() {
		  this.$refs.ruleForm.resetFields();
		  for(let key in this.form) {
		    this.form[key] = undefined;
		  }
		  this.fileList = [];
		  this.enclosureList = [];
		},
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$post("product", {...this.form}).then(r => {
            // console.log("添加产品相关", r.data);
            this.reset();
            this.$emit("success");
          })
        } else {
          return false;
        }
      });
    },
    handleUploadImgChange(fileList, urls) {
      console.log("上传图片组件传过来的值", urls);
      // this.form.image = JSON.stringify(urls);
      this.form.image = urls.length?urls[0]['filePath']:'';
      this.fileList = fileList;
    },
    handleUploadEnclosureChange(list, urls) {
      // console.log("上传附件的返回值===>", list, urls);
      this.enclosureList = list;
      // this.form.enclosure = JSON.stringify(urls);
      this.form.enclosure = urls.length?urls[0]['filePath']:'';
    }
  }
}
</script>